export function StatusSelect({ status, setStatus }) {
  const handleSelectChange = (event) => {
    setStatus(event.target.value);
  };

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={status}
        onChange={handleSelectChange}
        style={{ color: "rgb(104, 104, 104)" }}
      >
        <option value="">All</option>
        <option value="Active">Active</option>
        <option value="InActive">InActive</option>
      </select>
    </div>
  );
};